(function($) {
	function crfMaturityLevelScores(MaturityScoresOverall, isLegacyMode = false, year = '2025') {
		console.log("=== CRF MATURITY LEVEL SCORES START ===");
		console.log("crfMaturityLevelScores.js:05 Legacy mode:", isLegacyMode);

		if (!MaturityScoresOverall) {
			console.log("crfMaturityLevelScores.js:08 No MaturityScoresOverall provided. Exiting...");
			console.log("=== CRF MATURITY LEVEL SCORES END (NO DATA) ===");
			return;
		}

		console.log("crfMaturityLevelScores.js:13 Step 1: Validating score structure...");

		// Check if all keys are level-related (by numeric extraction)
		// Uses the extractNumericLevel utility (loaded via extractNumericLevel.js)
		const isFlat = Object.keys(MaturityScoresOverall).every(k => 
			window.extractNumericLevel ? window.extractNumericLevel(k) !== null : false
		);

		console.log("crfMaturityLevelScores.js:20 Level key check (isFlat):", isFlat);
		console.log("crfMaturityLevelScores.js:21 Provided keys:", Object.keys(MaturityScoresOverall));

		let scores;
		if (isFlat) {
			console.log("crfMaturityLevelScores.js:25 Using flat score structure directly.");
			scores = MaturityScoresOverall;
		} else {
			console.log("crfMaturityLevelScores.js:28 Step 2: Calculating overall maturity scores from categorized dataset...");
			scores = WebAssessmentCharts.calculateOverallMaturityScores(MaturityScoresOverall, isLegacyMode);
		}

		console.log("crfMaturityLevelScores.js:33 Final score object before UI formatting:", scores);

		const formatScore = (score) => {
			if (score === 'Not Applicable' || score === null || score === undefined) {
				return 'N/A';
			}
			const num = parseFloat(score);
			return isNaN(num)
				? 'N/A'
				: (Math.round(num * 100) / 100).toFixed(2);
		};

		console.log("crfMaturityLevelScores.js:42 Step 3: Updating UI elements...");
	if (isLegacyMode) {
		console.log("crfMaturityLevelScores.js:44 Using legacy P1-P4 score mapping...");
		$('.crf-maturity-1').text(formatScore(scores['P1']));
		$('.crf-maturity-2').text(formatScore(scores['P2']));
		$('.crf-maturity-3').text(formatScore(scores['P3']));
		$('.crf-maturity-4').text(formatScore(scores['P4']));
	} else {
		console.log("crfMaturityLevelScores.js:52 Using modern Level 1-5 score mapping...");
		var maturityEntries = [
			{ sel: '.crf-maturity-1', key: 'Foundational (Level 1)' },
			{ sel: '.crf-maturity-2', key: 'Hygiene (Level 2)' },
			{ sel: '.crf-maturity-3', key: 'Governed (Level 3)' },
			{ sel: '.crf-maturity-4', key: 'Controlled (Level 4)' },
			{ sel: '.crf-maturity-5', key: 'Monitored (Level 5)' }
		];
		maturityEntries.forEach(function(entry) {
			var formatted = formatScore(scores[entry.key]);
			$(entry.sel).text(formatted);
			if (formatted === 'N/A') {
				$(entry.sel).closest('tr').addClass('maturity-all-na').hide();
			} else {
				$(entry.sel).closest('tr').removeClass('maturity-all-na').show();
			}
		});
	}

		console.log("crfMaturityLevelScores.js:64 Step 4: Calculating Overall Score...");
		let sum = 0;
		let count = 0;

		// In legacy mode only P1–P4 are shown (2021 has no Level 5); overall must average only those.
		const levelsToAverage = isLegacyMode
			? ['P1', 'P2', 'P3', 'P4']
			: null;

		const keysToIterate = levelsToAverage || Object.keys(scores);
		keysToIterate.forEach(level => {
			const val = scores[level];
			console.log(`  Checking ${level}:`, val);

			if (val !== 'Not Applicable' && val !== null && val !== undefined) {
				const num = parseFloat(val);
				if (!isNaN(num)) {
					sum += num;
					count++;
				}
			}
		});

		console.log("crfMaturityLevelScores.js:75 Scorable levels:", count);
		console.log("crfMaturityLevelScores.js:76 Sum of scorable levels:", sum);

		const overallScore = count > 0 ? (Math.round((sum / count) * 100) / 100).toFixed(2) : '0.00';

		console.log("crfMaturityLevelScores.js:80 ✅ Final Overall Score:", overallScore);

		// Set year-specific global for mark-complete (e.g. overallCRFS2025maturity, overallCRFS2026maturity)
		var maturityKey = 'overallCRFS' + year + 'maturity';
		window[maturityKey] = overallScore;
		// Unrounded twin for finalize (update-project-completed.js), so the project page
		// saves the same full-precision score as the kanban finalize. Display stays 2dp.
		window[maturityKey + 'Exact'] = count > 0 ? sum / count : 0;
		if (year === '2025') {
			window.overallCRFS2025maturity = overallScore; // backward compatibility
		}
		$('.crf-maturitylevel-overall').text(overallScore);
		$('.audit-overall-value').text(overallScore);
		$('.gauge-value').text(overallScore);

		console.log("crfMaturityLevelScores.js:85 Updating UI elements counts:", {
			maturityOverall: $('.crf-maturitylevel-overall').length,
			auditOverall: $('.audit-overall-value').length
		});

		console.log("=== CRF MATURITY LEVEL SCORES END ===");
		return scores;
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = crfMaturityLevelScores;
	} else if (typeof window !== 'undefined') {
		window.crfMaturityLevelScores = crfMaturityLevelScores;
	}
})(jQuery);
